import { useDispatch } from 'react-redux';
import { setPushNotification } from './pushNotificationsSlice';
import { isSupported, onMessage } from 'firebase/messaging';
import { useCallback, useEffect } from 'react';
import { initMessaging } from '../../libs/firebase/firebase';

export default function PushNotificationsHandler() {
  const dispatch = useDispatch();

  const initMessagingListener = useCallback(async () => {
    const supported = await isSupported();

    if (!supported) {
      console.warn('Firebase Messaging no es soportado en este navegador');
      return;
    }

    const messagingInstance = await initMessaging();

    onMessage(messagingInstance, (payload) => {
      const { title, body } = payload.data;

      dispatch(setPushNotification({ title, body, show: true }));
    });
  }, [dispatch]);

  useEffect(() => {
    initMessagingListener();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
